 <p-blockUI [blocked]="blockedDocument">
 <div class="fixed inset-0 flex flex-col items-center justify-center bg-gray-900/50 z-50">
        <p-progressSpinner></p-progressSpinner>
        <span class="text-white text-lg mt-4">Loading...</span>
 </div>       
</p-blockUI>
 <p-dialog header="Update organization" [modal]="true" [(visible)]="visible" [style]="{ width: '70w' }" (onHide)="close()">
            <p-toast />
        <app-input-text [form]="organizationForm" field="name" label="Name" placeholder="Name"></app-input-text>

        <div class="flex justify-end gap-2">
            <p-button label="Cancel" severity="secondary" (click)="close()" />
            <p-button label="Save" (click)="save();" />
        </div>
</p-dialog>